import { Avatar, Flex, Typography } from "antd"

import { getInitials } from "./initials"

import styles from "./cells.module.less"

const { Text } = Typography

// A merchant in a table: an avatar with its initials, then the business account name (DAA-5-07),
// in the style of the account header of the admin user pages.
const MerchantCell = ({ name }) => (
  <Flex align="center" gap={8} className={styles.merchant}>
    {/* antd sizes the initials from `size` inline; the platform's 12px is set the same way. */}
    <Avatar size={24} className={styles.avatar} style={{ fontSize: 12 }}>
      {getInitials(name)}
    </Avatar>
    <Text ellipsis={{ tooltip: name }}>{name}</Text>
  </Flex>
)

export default MerchantCell
